module.exports = __webpack_public_path__ + "img/horizontal_1_1_7042.8c6df1a6.png";